import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LandingPageComponent } from './landing-page.component';
import { CommonModule } from '@angular/common';
import { DebounceConfig } from '../../config/debounce.config';
import { DirectivesModule } from '../directives/directives.module';
import { CreateApplicationComponent } from '../applications/create-application/create-application.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DraftApplicationsListComponent } from '../applications/draft-applications-list/draft-applications-list.component';
import { SubmittedApplicationsListComponent } from '../applications/submitted-applications-list/submitted-applications-list.component';
import { LayoutModule as CdkLayoutModule } from '@angular/cdk/layout';
import { UsanFormsModule } from '../applications/forms/usan-forms.module';

@NgModule({
  declarations: [
    LandingPageComponent,
      ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    DirectivesModule,
    CdkLayoutModule,
    MatIconModule,
    MatProgressSpinnerModule,
    UsanFormsModule
  ],
  providers: [
    DebounceConfig,
  ]
})
export class LandingPageModule {}
